import { memo } from 'react';

import type { IconProperties } from './types';

/**
 * Blox-Design plan toolbar — filled dropdown chevron (node 75644:10724).
 */
const CalenderIcon = ({ width = 16, height = 16, color = 'currentColor' }: IconProperties) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clip-path='url(#clip0_76347_2565)'>
      <path
        d='M0 5.33333V4.66667C0 2.82867 1.49533 1.33333 3.33333 1.33333H4V0.666667C4 0.298667 4.298 0 4.66667 0C5.03533 0 5.33333 0.298667 5.33333 0.666667V1.33333H10.6667V0.666667C10.6667 0.298667 10.9647 0 11.3333 0C11.702 0 12 0.298667 12 0.666667V1.33333H12.6667C14.5047 1.33333 16 2.82867 16 4.66667V5.33333H0ZM16 6.66667V12.6667C16 14.5047 14.5047 16 12.6667 16H3.33333C1.49533 16 0 14.5047 0 12.6667V6.66667H16ZM8 12.6667C8 12.2987 7.702 12 7.33333 12H4C3.63133 12 3.33333 12.2987 3.33333 12.6667C3.33333 13.0347 3.63133 13.3333 4 13.3333H7.33333C7.702 13.3333 8 13.0347 8 12.6667ZM12.6667 10C12.6667 9.632 12.3687 9.33333 12 9.33333H4C3.63133 9.33333 3.33333 9.632 3.33333 10C3.33333 10.368 3.63133 10.6667 4 10.6667H12C12.3687 10.6667 12.6667 10.368 12.6667 10Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_76347_2565'>
        <rect width='16' height='16' fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default memo(CalenderIcon);
